export class NotificationPreferences{
  notifPrefId: any;
  orgId: any;
  busType: any;
  orgType: any;
  notifType: any;
  firstName: any;
  lastName: any;
  mi: any;
  email: any;
  phone: any;
  phoneExt: any;
}